import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function ShieldFill(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.72 7.133c-.033-.532-.033-1.033-.033-1.534 0-.407-.324-.72-.746-.72-3.115 0-5.451-.876-7.43-2.691a.812.812 0 00-1.039 0C9.525 4.034 7.156 4.88 4.042 4.88c-.422 0-.747.312-.747.72 0 .5 0 1-.032 1.533-.065 5.008-.195 11.925 8.501 14.804l.26.063.26-.063c8.663-2.88 8.565-9.765 8.436-14.804zm-9.286 7.195a.78.78 0 01-.49.172h-.03a.654.654 0 01-.49-.23L8.25 12l1.04-.89 1.715 1.78 3.796-3.39.949.977-4.316 3.85z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(ShieldFill);
export default ForwardRef;